// extracted by mini-css-extract-plugin
export default {"desktop":"krK9__zkKyd44IJSrMVf","appContainer":"yecsBsEfoKvPmRULBnxM"};